module.exports = __webpack_public_path__ + "static/hkgrotesk-medium-313c838435fdae396417d8280d6e7921.woff2";